import React from 'react';
import PropTypes from 'prop-types';
import {GoogleMap} from '@react-google-maps/api';

import Context from '../../context';
import {Markers} from '..';
import {MAP_OPTIONS} from '../../constants';
import {getDifferenceInfoWindowPosition, moveInfoWindow} from '../../helpers';

let mapUpdated = false;
let tooltipUpdated = false;

const checkInfoWindow = () => {
  const difference = getDifferenceInfoWindowPosition();
  if (!difference) return;
  mapUpdated = false;
  tooltipUpdated = true;

  setTimeout(() => {
    if (!mapUpdated) {
      moveInfoWindow(difference);
      tooltipUpdated = false;
    }
  }, 150);
};

export const Map = ({options, markers}) => {
  const handleIdle = () => {
    if (tooltipUpdated) {
      const difference = getDifferenceInfoWindowPosition();
      if (difference) moveInfoWindow(difference);
      tooltipUpdated = false;
    }
  };

  const handleCenterChanged = () => (mapUpdated = true);

  return (
    <Context.Provider value={{checkInfoWindow}}>
      <GoogleMap
        mapContainerStyle={{
          height: '400px',
          width: '100%',
        }}
        options={{...MAP_OPTIONS, ...options}}
        onCenterChanged={handleCenterChanged}
        onIdle={handleIdle}
      >
        <Markers markers={markers} />
      </GoogleMap>
    </Context.Provider>
  );
};

Map.propTypes = {
  options: PropTypes.object,
  markers: PropTypes.arrayOf(PropTypes.object),
};

Map.defaultProps = {
  options: {},
  markers: [],
};
